module.exports = __webpack_public_path__ + "img/asian-special-2.3e6ecd27.jpg";